import { AboutBlock } from "../components/sections";

export default function About() {
  return <AboutBlock />;
}
